import React, {  useEffect, useState, useCallback, useMemo, useRef } from 'react'
import useMediaDataAndTabs from '../Components/commonV3/hooks/useMediaDataAndTabs';
import { MediaProvider, NavigationProvider, UIProvider } from '../Components/commonV3/context';
import MainViewer from '../Components/commonV3/MainViewer';
import BottomSlider from '../Components/commonV3/BottomSlider';
import RightGrid from '../Components/commonV3/RightGrid';
import useCarouselNavigation from '../Components/commonV3/hooks/useCarouselNavigation';
import { IMAGE_COMPRESSOR } from '../utils/imageCompressor';
import { ASSETS, TAB_ENUM } from '../Components/common/config';
import AnimatedLoader from '../Components/common/Loader';
import Tabs from '../Components/common/Tabs';
import { captureMetrics } from '../utils/captureMetrics';
import getUserMetrics from '../utils/getUserMetrics';
import UspComponentT2 from '../Components/commonV3/usp-hotspot/usp-component-t2';
import UspComponentT1 from '../Components/commonV3/usp-hotspot/usp-component-t1';
import UspComponentMobile from '../Components/commonV3/usp-hotspot/usp-component-mobile';
import { useDispatch } from 'react-redux';
import { setDropdownSelection } from '../Redux/Reducers/View360Reducer/View360ActionController';
import { useUspHotspot } from '../Components/commonV3/hooks/useUspHotspot';
import { getImageLoadingAnalytics, setImageLoadingCompleteCallback } from '../Components/common/ImageWithShimmer';
import TalkToSale from '../Components/commonV3/TalkToSale';
import UspComponentT2Mobile from '../Components/commonV3/usp-hotspot/usp-component-t2-mobile';


const CommonIframeV3 = () => {
    const { skuData, loading, selectedTemplate, selectedTab, tabs, carouselItems, setSelectedTab, dynamicTabImage, aspectRatio, skuName, mediaId, isMobile, enterpriseId, dealerVinId, sessionId, teamId, executionTime, apiCallFlag, isFirstSixExt, productFetchTimes, isHeroImageMode, heroImageIndex, isSplatHalfLoaded } = useMediaDataAndTabs();
    
    const queryParams = new URLSearchParams(window.location.search);
    const [isFullScreen, setIsFullScreen] = useState(false);

    //get a_spin from query params
    const a_spin = queryParams.get("a_spin");
    
    useEffect(()=>{
        if(isHeroImageMode){
        window.parent.postMessage(
                { type: 'LOADING_COMPLETED_HERO_IMAGE' },
                '*'
            )
        }
    },[isHeroImageMode])

    const skuDataKeys = skuData ? Object.keys(skuData) : []
    const isMobileFullScreenFromQuery = new URLSearchParams(window.location.search).get('isMobileFullScreen') === 'true';

    // Send post message when loading is completed (only when not in hero image mode)
    useEffect(() => {
        if (!loading && !isHeroImageMode && a_spin !== "0" && !isMobileFullScreenFromQuery) {
          window.parent.postMessage(
                { type: 'LOADING_COMPLETED' },
                '*'
            );
        }
    }, [loading, isHeroImageMode]);


    const dispatch = useDispatch();

    
    // Function to detect if the component is embedded in an iframe
    const isEmbedded = useCallback(() => {
        // Check if running in iframe
        const inIframe = window.self !== window.top;
        
        // Check domain (your approach)
        const isSpyneDomain = window.location.hostname.includes('spyne');
        
        // Check referrer for external embedding
        const hasExternalReferrer = document.referrer && 
            !document.referrer.includes('spyne');
        
        // Check query parameter for explicit embedding flag
        const urlParams = new URLSearchParams(window.location.search);
        const explicitEmbedded = urlParams.get('embedded') === 'true';
        
        return inIframe || (!isSpyneDomain && hasExternalReferrer) || explicitEmbedded;
    }, []);
    
    const [isEmbeddedContext, setIsEmbeddedContext] = useState(false);
    
    useEffect(() => {
        setIsEmbeddedContext(isEmbedded());
    }, [isEmbedded]);
    const [analyticsDataSent, setAnalyticsDataSent] = useState(false);
    const [conversationConfig, setConversationConfig] = useState(false);
    const [minimizedChat, setMinimizedChat] = useState(false);
    const [minimizedEmail, setMinimizedEmail] = useState(false);
    const [infoFormData, setInfoFormData] = useState(null);
    // const [autoCall, setAutoCall] = useState(false);
    const autoCall = useRef(0)
    
    const handleDropdownSelectionChange = (value) => {
        dispatch(setDropdownSelection(value));
    };

    const fetchConversationConfig = async (enterpriseId) => {
        if (!enterpriseId) {
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_BASEURL_API_SPYNE}/conversation/public/v1/conversation/get-conversation-config?enterpriseId=${enterpriseId}`);
            if (!response.ok) {
                setConversationConfig(false);
                return;
            }
            
            const data = await response.json();
            setConversationConfig(data?.isIframeEnabled);
        } catch (error) {
            setConversationConfig(false);
        }
    };

    useEffect(() => {
        if (enterpriseId) {
            fetchConversationConfig(enterpriseId);
        }
    }, [enterpriseId]);

    const { selectedIndex, handleLeft, handleRight, handleSelectThumbnail, skipAnimation } = useCarouselNavigation({ 
        carouselItems, 
        selectedTab, 
        setSelectedTab, 
        onDropdownSelectionChange: handleDropdownSelectionChange,
        initialIndex: isHeroImageMode && heroImageIndex !== null ? heroImageIndex : 0
    });
    const [isMobileFullScreen, setIsMobileFullScreen] = useState(isMobileFullScreenFromQuery || false);
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const [isSingleProduct, setIsSingleProduct] = useState(false);
    const [showOverlays, setShowOverlays] = useState(true);
    const [engagementStartTime, setEngagementStartTime] = useState(null);
    const hasStartedRef = useRef(false); // Keeps track without triggering re-renders
    const pauseStartRef = useRef(null);
    const totalPausedDurationRef = useRef(0);
    const pageViewStartTimeRef = useRef(null);
    const isFirstRenderRef = useRef(true)
    const [engagement, setEngagement] = useState({
        spin: 0,
        video: 0,
        image: 0,
        exterior360CardClick: 0,
        interior360CardClick: 0,
        imageCategoryWiseEngagement: {
            "360_exterior": 0,
            "interior": 0,
            "miscellaneous": 0
        },
        imagesViewed: []
    })
    const [prevIndex, setPrevIndex] = useState(selectedIndex)
    const [imageViewingTimeArray, setImageViewingTimeArray] = useState([]);
    const [totalTimeSpent, setTotalTimeSpent] = useState(0);
    const [timeSpentByImages, setTimeSpentByImages] = useState(0)
    const [timeSpentBy360, setTimeSpentBy360] = useState(0)
    const currentViewStartTimeRef = useRef(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const [zoomFeatureUsed, setZoomFeatureUsed] = useState([]);
    // Add local animation state for overlays
    
    const rightGridRef = useRef(null);
    
    // Track the width of rightGridRef
    const [rightGridWidth, setRightGridWidth] = useState(0);
    
    const getRightGridWidth = () => {
        if (rightGridRef.current) {
            const rect = rightGridRef.current.getBoundingClientRect();
            return rect.width;
        }
        return 0;
    };
    
    useEffect(() => {
        const updateWidth = () => {
            const width = getRightGridWidth();
            setRightGridWidth(width);
        };

        updateWidth();
        window.addEventListener('resize', updateWidth);
        
        return () => window.removeEventListener('resize', updateWidth);
    }, [rightGridRef.current]);
    
    
    const isListing = queryParams.get("isListing");
    const hotspot_val = queryParams.get("hotspot") ? JSON.parse(queryParams.get("hotspot")) : true;
    useEffect(() => {
        pageViewStartTimeRef.current = Date.now();
    }, []);
    
    useEffect(() => {
        const handleScriptAnalytics = (event) => {
            if (event.data.type === 'script_analytics') {
                const { scriptTime, vinFetchTime, xpathForDivTime } = event.data.data;
                captureMetrics({
                    scriptTime,
                    vinFetchTime,
                    xpathForDivTime,
                    sessionId
                })
            }
        };
        window.addEventListener('message', handleScriptAnalytics);
        
        return () => {
            window.removeEventListener('message', handleScriptAnalytics);
        };
    }, []);
    const sendViewAnalytics = async () => {
        const userMetrics = await getUserMetrics()
        const imageLoadingData = getImageLoadingAnalytics();
        
        const analyticsData = {
            commonIframeLoadingTime: executionTime,
            methodOfIframeData: apiCallFlag,
            spinJsonFetchTime: productFetchTimes.spin,
            imageJsonFetchTime: productFetchTimes.image,
            videoJsonFetchTime: productFetchTimes.video,
            ...userMetrics,
            ...(imageLoadingData && {
                loadTime: imageLoadingData.imageLoadTime,
                imageCount: imageLoadingData.imageCount
            })
        };

        captureMetrics({dealerVinId, teamId, analyticsData, apiCallFlag, sessionId}); 
        setAnalyticsDataSent(true);
    }

    useEffect(() => {
        setImageLoadingCompleteCallback(() => {
            if (teamId && executionTime && apiCallFlag && sessionId && !analyticsDataSent) {
                sendViewAnalytics();
            }
        });
    }, [teamId, executionTime, apiCallFlag, sessionId, analyticsDataSent]);

    useEffect(() => {
        if(teamId && executionTime && apiCallFlag && sessionId && !analyticsDataSent) {
            const timeoutId = setTimeout(() => {
                if (!analyticsDataSent) {
                    sendViewAnalytics();
                }
            }, 2000); 
            
            return () => clearTimeout(timeoutId);
        }
    },[teamId, executionTime, apiCallFlag, sessionId, analyticsDataSent]);

    const calculateMedian = (numbers) => {
        if (numbers.length === 0) return 0;
        const sorted = [...numbers].sort((a, b) => a - b);
        const mid = Math.floor(sorted.length / 2);
        return sorted.length % 2 === 0
          ? (sorted[mid - 1] + sorted[mid]) / 2
          : sorted[mid];
      };
    
      
    const handleRecordEngagement = (product, imageData) => {
        // Check if engagement for the product is already recorded as 1
        if (engagement[product] === 1 && product !== "image") {
            return; // Skip if already recorded and not an image
        }

        // Create an updated engagement object
        let curEngagement = {
            ...engagement,
            [product]: 1
        };
        
        // If this is an image type and we have imageData
        if (product === "image" && imageData) {
            // Get image category from data
            const imageCategory = imageData.image_category?.toLowerCase() || "";
            const imageId = imageData.image_id;
            
            // Map the category to one of our three tracking categories
            let categoryKey = "miscellaneous";
            if (imageCategory.includes("360_exterior") || imageCategory.includes("exterior")) {
                categoryKey = "360_exterior";
            } else if (imageCategory.includes("interior")) {
                categoryKey = "interior";
            }
            
            // Update category engagement count to 1
            curEngagement.imageCategoryWiseEngagement = {
                ...curEngagement.imageCategoryWiseEngagement,
                [categoryKey]: 1
            };
            
            // Add the image_id to the viewed array if not already there
            if (imageId && !curEngagement.imagesViewed.includes(imageId)) {
                curEngagement.imagesViewed = [...curEngagement.imagesViewed, imageId];
            }
        }
        
        setEngagement(curEngagement);

        // Call captureMetrics since this is a new engagement
        captureMetrics({ sessionId, teamId, engagement: curEngagement });
    };

      const handleUpdateTimeSpentBy360 = (updatedTimeSpent) =>{
        setTimeSpentBy360(prev => prev + updatedTimeSpent);
      }

      const handleUpdateImageViewingTimeArray = (viewingTime) => {
        setImageViewingTimeArray((prev) => {
          const existingIndex = prev.findIndex(item => item.indexVisited === prevIndex);
          if (existingIndex !== -1) {
            // If index already exists, update its viewing time
            const updatedArray = [...prev];
            updatedArray[existingIndex] = {
              ...updatedArray[existingIndex],
              viewingTime: updatedArray[existingIndex].viewingTime + (viewingTime/1000)
            };
            return updatedArray;
          } else {
            // If index is new, add new entry
            return [
              ...prev,
              { 
                indexVisited: prevIndex, 
                viewingTime: (viewingTime)/1000 
              }
            ];
          }
        });
      }

      useEffect(()=> {
        const currTimeSpent = timeSpentBy360 + timeSpentByImages
        setTotalTimeSpent(currTimeSpent)
        hasStartedRef.current && captureMetrics({
            sessionId, 
            teamId, 
            timeSpent: currTimeSpent,
            zoomFeatureUsed: zoomFeatureUsed.length > 0 ? zoomFeatureUsed : undefined
        })
      },[timeSpentBy360, timeSpentByImages, zoomFeatureUsed])

    useEffect(()=> {
        if(isFirstRenderRef.current){
            isFirstRenderRef.current = false;
            return;
        }
        
        // Get the current item data if available
        const currentItem = carouselItems[selectedIndex] || {};
        
        if (selectedTab === "image") {
            handleRecordEngagement("image", currentItem?.data);
        } else if (selectedTab === "360") {
            handleRecordEngagement("exterior360CardClick");
        } else if (selectedTab === "360Int") {
            handleRecordEngagement("interior360CardClick");
        }

       const now = Date.now();
       const viewingTime = now - (currentViewStartTimeRef.current || now);
       currentViewStartTimeRef.current = now;

        // Update the viewing times array
        viewingTime !== 0 && handleUpdateImageViewingTimeArray(viewingTime)
        setPrevIndex(selectedIndex)
        
    }, [selectedIndex])

    useEffect(()=> {
        // // Calculate median and number of visited indexes
        const allViewingTimes = imageViewingTimeArray.map((item) => item.viewingTime)
        const median = calculateMedian(allViewingTimes);
        const visitedIndexes = allViewingTimes.length;

        // Compute the time to send to handleUpdateTimeSpent
        const timeToSend = median * visitedIndexes;
        setTimeSpentByImages(timeToSend)

    },[imageViewingTimeArray])


    const handleBeforeUnload = () => {
        if(pageViewStartTimeRef?.current > 0){
            const now = Date.now();
            let pausedDuration = totalPausedDurationRef.current || 0;
            
            // If the tab is currently blurred (user left without returning), add this final pause duration
            if (pauseStartRef?.current) {
                const finalPauseDuration = now - pauseStartRef.current;
                pausedDuration += finalPauseDuration;
            }
            
            const totalViewDuration = now - pageViewStartTimeRef.current;
            const activeViewDuration = totalViewDuration - pausedDuration;
            const storedTeamId = sessionStorage.getItem('teamId');
            captureMetrics({
                sessionId, 
                teamId: storedTeamId, 
                totalViewDuration: (totalViewDuration/1000), 
                activeViewDuration: (activeViewDuration/1000),
                zoomFeatureUsed: zoomFeatureUsed.length > 0 ? zoomFeatureUsed : undefined,
                unLoadFlag: true
            });
        }
        sessionStorage.removeItem('sessionId');
        sessionStorage.removeItem('teamId');
    };

    useEffect(() => {
        const handleBlur = () => {
            pauseStartRef.current = Date.now();
        };

        const handleFocus = () => {
            if (pauseStartRef?.current) {
                const now = Date.now();
                const pauseDuration = now - pauseStartRef?.current;
                totalPausedDurationRef.current += pauseDuration;
                pauseStartRef.current = null;            
            }
        };

        // For desktop browsers
        window.addEventListener('beforeunload', handleBeforeUnload);
        
        // For mobile browsers
        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);
        window.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                // Save metrics when page becomes hidden (common mobile scenario)
                handleBeforeUnload();
            }
        });
        
        return () => {
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('visibilitychange', handleBeforeUnload);
        };
    }, []);
    // Start engagement time on first interaction
    const handleStartEngagementTime = () => {
        if (!hasStartedRef.current) {
            const now = Date.now();
            setEngagementStartTime(now);
            hasStartedRef.current = true;
        }
    };

    const handleShareModal = useCallback(() => {
        setShareModalOpen(true);
    }, []);

    const navigationValue = {
        carouselItems,
        selectedIndex,
        handleLeft,
        handleRight,
        handleSelectThumbnail,
        skipAnimation,
        setSelectedTab
    }
    const uiValue = {
        isExpanded,
        setIsExpanded,
        isSingleProduct,
        showOverlays,
        setShowOverlays,
        handleShareModal,
        handleRecordEngagement,
        sessionId,
        handleUpdateTimeSpentBy360,
        handleStartEngagementTime,
        zoomFeatureUsed,
        setZoomFeatureUsed,
        // showCall,
        // setShowCall: handleShowCall,
        // showEmail,
        // setShowEmail: handleShowEmail,
        // showChat,
        // setShowChat: handleShowChat,
        conversationConfig,
        // autoCall,
        isEmbeddedContext,
    };

    useEffect(() => {
        if (tabs?.length === 1) {
            if( (tabs[0]?.key === TAB_ENUM.VIDEO_VIEW ||  tabs[0]?.key === TAB_ENUM.THREE_SIXTY_VIEW)){
                setIsSingleProduct(true);
            }else{
                setIsSingleProduct(false);
            }
        }else{
            setIsSingleProduct(false);
        }
    }, [tabs]);

   

    const handleMobileFullScreen = () => {
        setIsMobileFullScreen(true);
    };

    const handleFullScreen = () => {
        setIsFullScreen(true);
        // Send analytics data for fullscreen usage
        captureMetrics({
            sessionId,
            teamId,
            fullScreenDone: true
        });
    };
    const handleMobileExitFullScreen = () => {
        setIsMobileFullScreen(false);
        window.parent.postMessage(
            { type: 'EXIT_MOBILE_FULLSCREEN' },
            '*'
        );
    };

    useEffect(()=> {
        if(isMobileFullScreen && isMobile){
        window.parent.postMessage(
                { type: 'FULLSCREEN_MODE_CHANGED_MOBILE', isMobileFullScreen, selectedIndex, selectedTab },
                '*'
            );
        }
    },[isMobileFullScreen])

    useEffect(() => {
        if(isFullScreen){
        // alert(selectedTab)
        handleSelectThumbnail(selectedIndex,selectedTab);
        window.parent.postMessage(
            { type: 'FULLSCREEN_MODE_CHANGED', isFullScreen, selectedIndex, selectedTab },
            '*'
        );    

    }
    }, [isFullScreen]);

    const handleMessage = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if(event?.data?.type === "MOBILE_FULLSCREEN_EXITED"){
            setIsMobileFullScreen(false);
            return;
        }
        if (event?.data && typeof event?.data?.closeFullScreen !== "undefined") {
            setIsFullScreen(false);
            handleSelectThumbnail(event?.data?.selectedIndex,event?.data?.selectedTab);
        }else if(event?.data && typeof event?.data?.showFullScreenModal !== "undefined"){
            setIsFullScreen(true);
            // Send analytics data for fullscreen usage triggered via message
            captureMetrics({
                sessionId,
                teamId,
                fullScreenDone: true
            });
            handleSelectThumbnail(event?.data?.selectedIndex,event?.data?.selectedTab);
        }
      };

    useEffect(()=> {
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage)
        }
    },[])

    const {
        combinedHotspotData
      } = useUspHotspot()

    // console.log(imageViewingTimeArray, "imageviewingtimearray")
    // console.log(timeSpentBy360, "timespentby360")
    // console.log(timeSpentByImages, "timespentbyimages")
    // console.log(totalTimeSpent, "totaltimespent")
    // console.log(engagement, "engagemet")

    // Animation classes
    const overlayBase = "absolute inset-0 z-[100] transition-all duration-300 ease-in-out flex flex-col";
    const overlayShow = "translate-y-0 opacity-100 pointer-events-auto";
    const overlayHide = "translate-y-full opacity-0 pointer-events-none";

    return (
        !isHeroImageMode && !loading && (!skuData.isMediaPresent)) ?
        !isHeroImageMode && <img className="w-full h-full max-sm:object-contain" src={IMAGE_COMPRESSOR({ url: ASSETS.other.noSkuDone })} alt="vin is in process" />
        : (
            <>
                {
                    !isHeroImageMode && loading ? <AnimatedLoader /> :
                    <MediaProvider value={{skuData,
                        loading,
                        selectedTemplate,
                        selectedTab,
                        tabs,
                        dynamicTabImage,
                        aspectRatio,
                        skuName,
                        mediaId,
                        autoCall,
                        enterpriseId,
                        dealerVinId,
                        isSplatHalfLoaded}}>
                        <NavigationProvider value={navigationValue}>
                            <UIProvider value={uiValue}>
                            {!isMobile ? (
                                <div className={`w-full h-full relative flex flex-col overflow-hidden`} onClick={handleStartEngagementTime}>
                                    {selectedTemplate === "t1" ? 
                                    (
                                        <div className={`w-full h-dvh flex flex-col overflow-hidden ${isSingleProduct && ''}`}>
                                            <div className={`w-full max-h-[85%] ${isSingleProduct ? 'max-h-full' : 'pt-2'} `} style={{
                                                aspectRatio: aspectRatio
                                            }}>
                                                <MainViewer enterpriseId={enterpriseId} isExpanded={isExpanded} setIsExpanded={setIsExpanded} template={selectedTemplate} handleFullScreen={handleFullScreen} isFullScreen={isFullScreen} dynamicTabImage={dynamicTabImage} isMobileFullScreen={isMobileFullScreen} handleMobileExitFullScreen={handleMobileExitFullScreen} isMobileFullScreenFromQuery={isMobileFullScreenFromQuery} />
                                            </div>
                                            {
                                                !isSingleProduct && (
                                                    <>
                                                        {<div className='w-full h-[20%] overflow-x-scroll'>
                                                            <BottomSlider />
                                                        </div>}
                                                        {/* {!isListing && <div className='w-full z-30'>
                                                            <UspComponentT1 handleSelectThumbnail={handleSelectThumbnail} />
                                                        </div>} */}
                                                    </>
                                                )
                                            }
                                        </div>
                                    ) : (
                                        <div className={`w-screen h-dvh flex ${isSingleProduct && ' py-2 items-center justify-center'}`}>
                                            <div className={`h-full ${isSingleProduct ? 'max-w-full' : 'max-w-[80%] p-2'}`} style={{
                                                aspectRatio: aspectRatio
                                            }}>
                                                <MainViewer enterpriseId={enterpriseId} isExpanded={isExpanded} setIsExpanded={setIsExpanded} template={selectedTemplate} handleFullScreen={handleFullScreen} isFullScreen={isFullScreen} dynamicTabImage={dynamicTabImage} infoFormDataT2={infoFormData} isMobileFullScreen={isMobileFullScreen} handleMobileExitFullScreen={handleMobileExitFullScreen} isMobileFullScreenFromQuery={isMobileFullScreenFromQuery} />
                                                {/* Add UspComponentT2Mobile over MainViewer when isMobileFullScreen is true */}
                                                {!isSingleProduct && !isListing && isMobileFullScreenFromQuery && (
                                                    <div className={`${isExpanded ? 'absolute sm:top-[-5%] h-sm:top-[5%] md:top-[5%] left-[-1%] h-sm:left-[0%] md:left-[1%] z-[1000] pointer-events-none' : 'hidden'}`}>
                                                        <div className="pointer-events-auto">
                                                            <UspComponentT2Mobile handleSelectThumbnail={handleSelectThumbnail}/>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {
                                                !isSingleProduct && (
                                                    <div ref={rightGridRef} className={`${isExpanded ? "relative overflow-hidden pt-2" : "overflow-y-scroll"} w-full h-[98%] max-w-[80%] scrollbar-hide`}>
                                                        {!isListing && 
                                                        <div className={`${isExpanded ? 'absolute top-0 left-0 z-[1000]' : 'hidden'} w-full`}>
                                                         {/* Only show UspComponentT2 here when NOT in mobile fullscreen */}
                                                            {!isMobileFullScreenFromQuery && (
                                                                <UspComponentT2 handleSelectThumbnail={handleSelectThumbnail}/>
                                                            )} 
                                                        </div>}
                                                        {/* RightGrid Container with Overlay Support */}
                                                        <div className='w-full h-full relative z-10'>
                                                            {/* Always show RightGrid */}
                                                            <div className={`${isExpanded && !isMobileFullScreenFromQuery ? '[filter:blur(3px)]' : ''}`}>
                                                                <RightGrid />
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                )
                                            }

                                        </div>
                                    )}
                                    {/* <FullScreenModal isOpen={isFullScreen} onClose={() => setIsFullScreen(false)} carouselItems={carouselItems} /> */}

                                    {/* {
                                        shareModalOpen && <ShareModal onClose={() => setShareModalOpen(false)} downloadEnabled={true} />
                                    } */}
                                </div> 
                            ) : (
                                <div className={`w-full h-full flex flex-col overflow-hidden`} onClick={handleStartEngagementTime}>
                                    <div className={`w-full h-full py-[6px] px-3`}>
                                        <MainViewer enterpriseId={enterpriseId} isExpanded={isExpanded} setIsExpanded={setIsExpanded} template={"mobile"} handleFullScreen={()=>{}} handleMobileFullScreen={handleMobileFullScreen} isFullScreen={false} isMobileFullScreen={isMobileFullScreen} handleMobileExitFullScreen={handleMobileExitFullScreen} dynamicTabImage={dynamicTabImage} isFirstSixExt={isFirstSixExt} isMobileFullScreenFromQuery={isMobileFullScreenFromQuery} isHeroImageMode={isHeroImageMode} />
                                    </div>
                                    {/* <div className={`bg-blue-lightestBlue shadow-md shadow-black-8 sm:rounded-b-md md:rounded-2xl max-md:w-full md:w-max z-[999]`}>
                                        {tabs?.length > 1 && <Tabs
                                            options={tabs}
                                            onSelect={(option) => {
                                                setSelectedTab(option?.key);
                                                const firstItemIndex = carouselItems.findIndex(item => item.type === option?.key);
                                                if (firstItemIndex !== -1) {
                                                    handleSelectThumbnail(firstItemIndex, option?.key)
                                                }
                                            }}
                                            isV3={true}
                                            selectedTab={selectedTab}
                                        />}
                                    </div> */}

                                    {!isListing && !isSingleProduct && <div className={`w-full h-[60px] overflow-x-scroll`}>
                                        {/* <UspComponentMobile/> */}
                                        <BottomSlider template={"mobile"} isMobile={true}/>
                                    </div>}

                                </div>
                            )}    
                    </UIProvider>
                    </NavigationProvider>
                </MediaProvider>
                }
            </>
        )
}

export default CommonIframeV3